import { Injectable, Inject } from "@angular/core";

import { Cache } from "#models/cache.interface";

@Injectable()
export class LocalStorageCache implements Cache {
    private static usedKeys: {[index:string]:any} = {};

    constructor(@Inject("TokenNoOneWillEverUse") private cacheKey: string) {
        if (LocalStorageCache.usedKeys[cacheKey]) {
            throw new Error("Cache key already exists: " + cacheKey);
        }

        LocalStorageCache.usedKeys[cacheKey] = true;
    }

    /**
     * @description
     * Set value of the local storage item to the key with the next available index
     *
     * @param {string} value the value for the item being stored
     */
    public setItem(value: string): void {
        const index: number = this.getIndex();
        window.localStorage.setItem(this.cacheKey + "-" + index, value);
    }

    /**
     * @description
     * Get an array of items from local storage
     *
     * @param {number} index index of items to retrieve
     * @return {array} return the array of stored values
     */
    public getItems(index: number): Array<string> {
        const queue: Array<string> = [];

        for (let i = 0; i < index; i++) {
            queue.push(this.getItem(i));
        }

        return queue;
    }

    /**
     * @description
     * Remove local storage messages and sort any remaining messages to zero index.
     *
     * @param {number} total total items to remove
     * @param {function} callback callback function to run after method completes
     */
    public removeAndSort(total: number, callback: () => any): void {
        const index = this.getIndex();

        for (let i = 0; i < total; i++) {
            window.localStorage.removeItem(this.cacheKey + "-" + i);
        }

        // If our total is < the current index we need to sort messages.
        if (total < index) {
            for (let i = total; i < index; i++) {
                this.setItem(this.getItem(i));
                window.localStorage.removeItem(this.cacheKey + "-" + i);
            }
        }

        callback();
    }

    /**
     * @description
     * Get the index of the cachekey
     *
     * @return {number} the next index available
     */
    public getIndex(): number {
        let count = 0;

        while (window.localStorage.getItem(this.cacheKey + "-" + count)) {
            count++;
        }

        return count;
    }

    /**
     * @description
     * Get an item from local storage.
     *
     * @param {number} index index of item to retrieve
     * @return {string} return the string value stored
     */
    private getItem(index: number): string {
        const getItemFromLocal = window.localStorage.getItem(this.cacheKey + "-" + index)
        return getItemFromLocal? getItemFromLocal : "";
    }
}
